export const toggleFilter = (e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement>): void => {
  const currentLocation = new URLSearchParams(location.search)
  const target = e.target as HTMLAnchorElement;
  const filterField: string | null = target.dataset.field || null
  const filterValue: string | null = target.dataset.value || null
  let filterFieldAndValueExists = false

  if (!filterField || !filterValue) {
    return
  }

  for (const [key, value] of currentLocation.entries()) {
    if ((key.includes(filterField) && value === filterValue)) {
      filterFieldAndValueExists = true
      currentLocation.delete(key, filterValue)
    }
  }

  if (!filterFieldAndValueExists) {
    currentLocation.append(`filter.${filterField}`, filterValue)
  }
  const newUrl = `${window.location.pathname}?${currentLocation.toString()}`
  window.history.replaceState({}, '', newUrl)
}

export const toggleSorting = (e: React.MouseEvent<HTMLAnchorElement>): void => {
  const currentLocation = new URLSearchParams(location.search)
  const target = e.currentTarget; // use currentTarget for the anchor element
  const filterField: string | null = target.dataset.field || null
  const filterValue: string | null = target.dataset.value || null

  if (!filterField || !filterValue) {
    return
  }

  // Check if the current sorting parameter exists in the URL
  const currentSortField = Array.from(currentLocation.keys()).find(key => key.startsWith('sort.'))
  const currentSortValue = currentSortField ? currentLocation.get(currentSortField) : null

  if (currentSortField === `sort.${filterField}` && currentSortValue === filterValue) {
    // If the current sorting parameter matches the one from the event, remove it
    currentLocation.delete(currentSortField)
  } else {
    // Remove any existing sort parameters
    for (const key of currentLocation.keys()) {
      if (key.startsWith('sort.')) {
        currentLocation.delete(key)
      }
    }

    // Add the new sort parameter
    currentLocation.append(`sort.${filterField}`, filterValue)
  }

  const newUrl = `${window.location.pathname}?${currentLocation.toString()}`
  window.history.replaceState({}, '', newUrl)
}

export const toggleReadyToShip = (): void => {
  const currentLocation = new URLSearchParams(location.search)
  const filterField: string = 'ss_stock_status'
  const filterValue: string = 'Ready to Ship'

  const keysToDelete = []
  for (const [key] of currentLocation.entries()) {
    if (key.startsWith('page.') || key.startsWith('sort.') || key.startsWith('filter.')) {
      keysToDelete.push(key)
    }
  }

  keysToDelete.forEach(key => currentLocation.delete(key))
  currentLocation.append(`filter.${filterField}`, filterValue)

  const newUrl = `${window.location.pathname}?${currentLocation.toString()}`
  window.history.replaceState({}, '', newUrl)
}

export const checkActiveFilter = (field: string, value: string): boolean => {
  const currentLocation = new URLSearchParams(location.search)
  const filterField: string | null = field
  const filterValue: string | null = value


  if (!filterField || !filterValue) {
    return false
  }

  for (const [key, val] of currentLocation.entries()) {
    if (key.includes(filterField) && val === filterValue) {
      return true
    }
  }

  return false

}

export const checkAnyActiveFilters = (): boolean => {
  const currentLocation = new URLSearchParams(location.search)
  for (const [key, val] of currentLocation.entries()) {
    if (key.startsWith('sort.')) {
      return true
    }
  }
  return false
}